import React, { useState, useEffect } from "react";
import "./Style/Enddate.css";

export default function Enddate() {
  const [date, setDate] = useState(null);
  const [day, setDay] = useState(0);
  const [month, setMonth] = useState(0);
  const [year, setYear] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      let d = new Date();
      setDay(d.getDay());
      setMonth(d.getMonth());
      setDate(d.getDate());
      setYear(d.getFullYear());
    }, 10);
  }, [date]);

  return (
    <div className="date-content">
      <div className="day">
        {day === 1 ? (
          <div>
            <h2>Monday</h2>
          </div>
        ) : day === 2 ? (
          <div>
            <h2>Tuesday</h2>
          </div>
        ) : day === 3 ? (
          <div>
            <h2>Wednesday</h2>
          </div>
        ) : day === 4 ? (
          <div>
            <h2>Thursday</h2>
          </div>
        ) : day === 5 ? (
          <div>
            <h2>Friday</h2>
          </div>
        ) : day === 6 ? (
          <div>
            <h2>Saturday</h2>
          </div>
        ) : (
          <div>
            <h2>Sunday</h2>
          </div>
        )}
      </div>
      <div className="month">
        {month === 0 ? (
          <div>
            <h3>January, {`${date} ${year}`}</h3>
          </div>
        ) : month === 1 ? (
          <div>
            <h3>February, {`${date} ${year}`}</h3>
          </div>
        ) : month === 2 ? (
          <div>
            <h3>March, {`${date} ${year}`}</h3>
          </div>
        ) : month === 3 ? (
          <div>
            <h3>April, {`${date} ${year}`}</h3>
          </div>
        ) : month === 4 ? (
          <div>
            <h3>May, {`${date} ${year}`}</h3>
          </div>
        ) : month === 5 ? (
          <div>
            <h3>June, {`${date} ${year}`}</h3>
          </div>
        ) : month === 6 ? (
          <div>
            <h3>July, {`${date} ${year}`}</h3>
          </div>
        ) : month === 7 ? (
          <div>
            <h3>August, {`${date} ${year}`}</h3>
          </div>
        ) : month === 8 ? (
          <div>
            <h3>September, {`${date} ${year}`}</h3>
          </div>
        ) : month === 9 ? (
          <div>
            <h3>October, {`${date} ${year}`}</h3>
          </div>
        ) : month === 10 ? (
          <div>
            <h3>November, {`${date} ${year}`}</h3>
          </div>
        ) : (
          <div>
            <h3>December, {`${date} ${year}`}</h3>
          </div>
        )}
      </div>
    </div>
  );
}
